import { EntryEventConfig } from '../models/EntryEventConfig';
import { EntryFormEventInfo } from '../models/EntryFormEventInfo';
import { EntryFormEventInfoClass } from '../models/EntryFormEventInfoClass';
import { EntryFormRecordData } from '../models/EntryFormRecordData';
import _ from 'lodash';

export function calcDogEntryFee(entry: EntryFormRecordData, entryEvents: EntryEventConfig[]) {
  let entryFee = 0;
  const msgs: string[] = [];
  const isJuniorHandler = _.get(entry, 'jrHandlerName', '').trim() !== '';
  entry.eventEntries.forEach((eventEntry: EntryFormEventInfo) => {
    let numIsEntered = 0;
    const entryEventsIndex = _.findIndex(entryEvents, (val: EntryEventConfig) => val.eventNum === eventEntry.eventNum);
    const hasJuniorHandlerPrices = entryEvents[entryEventsIndex].juniorPrices.length > 0;
    eventEntry.classes.forEach((eventClass: EntryFormEventInfoClass) => {
      if (eventClass.isEntered) {
        const specialPricesIndex = _.findIndex(entryEvents[entryEventsIndex].specialPrices, (val: any) => eventClass.name === val.class);
        let price = '0';
        numIsEntered++;
        if (specialPricesIndex > -1) {
          const specialPricesThisClass: any = entryEvents[entryEventsIndex].specialPrices[specialPricesIndex];
          if (numIsEntered <= specialPricesThisClass.prices.length) {
            price = specialPricesThisClass.prices[numIsEntered - 1];
          } else {
            if (specialPricesThisClass.prices.length > 0) {
              price = specialPricesThisClass.prices[specialPricesThisClass.prices.length - 1];
            }
          }
        } else if (isJuniorHandler && hasJuniorHandlerPrices) {
          if (numIsEntered <= entryEvents[entryEventsIndex].juniorPrices.length) {
            price = entryEvents[entryEventsIndex].juniorPrices[numIsEntered - 1];
          } else {
            price = entryEvents[entryEventsIndex].juniorPrices[entryEvents[entryEventsIndex].juniorPrices.length - 1];
          }
        } else {
          if (numIsEntered <= entryEvents[entryEventsIndex].prices.length) {
            price = entryEvents[entryEventsIndex].prices[numIsEntered - 1];
          } else {
            if (entryEvents[entryEventsIndex].prices.length > 0) {
              price = entryEvents[entryEventsIndex].prices[entryEvents[entryEventsIndex].prices.length - 1];
            }
          }
        }
        if (price.trim() === '' || isNaN(parseFloat(price))) {
          price = '0';
        }
        if (price === '0') {
          msgs.push(`ERROR: cannot calculate the price: numIsEntered=${numIsEntered} isJuniorHandler=${isJuniorHandler} specialPricesIndex=${specialPricesIndex}
            Club=${_.get(entryEvents[0], 'clubName', '')} Date=${_.get(entryEvents[0], 'date', '')} EventNum=${_.get(entryEvents[0], 'eventNum', '')}
            entryEventsIndex=${entryEventsIndex} Class=${eventClass.name}
            prices=${_.get(entryEvents[entryEventsIndex], `prices`, []).toString()}
            juniorPrices=${_.get(entryEvents[entryEventsIndex], `juniorPrices`, []).toString()}
            specialPrices=${JSON.stringify(_.get(entryEvents[entryEventsIndex], `specialPrices`, []))}
            `);
        }
        entryFee += parseFloat(price);
      }
    });
  });
  return { entryFee, msgs };
}

export function calcOwnerEntryFees(entries: EntryFormRecordData[], serviceFee: any, serviceFeeBasis: string, catalogFee: number) {
  let sumEntryFee: number = 0;
  let sumServiceFee: number = 0;
  let totalFees: number = 0;
  const msgs: string[] = [];
  entries.forEach((entry: EntryFormRecordData) => {
    if (entry.entryFee === undefined || entry.entryFee === null || typeof entry.entryFee !== 'number') {
      const entryFeeString = entry.entryFee === undefined ? 'undefined' : entry.entryFee === null ? 'null' : entry.entryFee;
      msgs.push(`ERROR: calcOwnerEntryFees: entry.entryFee=${entryFeeString} Owner=${entry.owners} CallName=${entry.callName} entry=${JSON.stringify(entry)}`);
    } else {
      sumEntryFee += entry.entryFee;
    }
  });
  if (serviceFee === undefined || serviceFee === null || typeof serviceFee !== 'number') {
    const sumServiceFeeString = serviceFee === undefined ? 'undefined' : serviceFee === null ? 'null' : serviceFee;
    msgs.push(`ERROR: calcOwnerEntryFees: serviceFee=${sumServiceFeeString} serviceFeeBasis=${serviceFeeBasis} Owner=${entries[0].owners} entries=${JSON.stringify(entries)}`);
  } else {
    sumServiceFee = serviceFeeBasis === 'owner' ? serviceFee : serviceFee * entries.length;
  }
  totalFees = sumEntryFee + sumServiceFee + catalogFee;

  return { sumEntryFee, sumServiceFee, totalFees, msgs };
}
